import React from "react";
import { Package, BookOpen, Gift } from "lucide-react";

const TABS = [
  { id: "sbusta", label: "Sbusta", icon: Package, testId: "nav-sbusta-tab" },
  { id: "collezione", label: "Collezione", icon: BookOpen, testId: "nav-collezione-tab" },
  { id: "bonus", label: "Bonus", icon: Gift, testId: "nav-bonus-tab" },
];

export default function BottomNav({ active, onChange, bonusDot }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-lg border-t border-sky-100 shadow-[0_-6px_24px_rgba(14,116,180,0.08)]">
      <div className="max-w-md sm:max-w-2xl lg:max-w-5xl mx-auto px-6 py-1.5 flex items-stretch justify-between">
        {TABS.map((t) => {
          const Icon = t.icon;
          const on = active === t.id;
          return (
            <button
              key={t.id}
              onClick={() => onChange(t.id)}
              data-testid={t.testId}
              className={`relative flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-2xl transition-colors ${
                on ? "text-pink-600" : "luma-muted"
              }`}
            >
              <span
                className={`flex items-center justify-center w-11 h-8 rounded-full transition-all ${
                  on ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md" : ""
                }`}
              >
                <Icon size={19} />
              </span>
              <span className="text-[11px] font-bold">{t.label}</span>
              {t.id === "bonus" && bonusDot && (
                <span className="absolute top-1 right-[26%] w-2.5 h-2.5 rounded-full bg-pink-500 ring-2 ring-white" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
